/* Riga chiave/valore delle schermate minori, e il gruppo che le contiene.
 *
 * Sono righe di sola lettura: SemBot non ha endpoint per salvare preferenze
 * utente (non esiste nemmeno un CRUD utenti). Fingere un interruttore che non
 * scrive da nessuna parte sarebbe peggio che non averlo, quindi qui si legge e
 * basta, e dove il valore arriva dal backend si dice da dove.
 */

import type { ReactNode } from 'react';
import './minori.css';

export function GruppoVoci({ titolo, children }: { titolo: string; children: ReactNode }) {
  return (
    <section className="sb-m-gruppo">
      <div className="sb-m-gruppo__titolo">{titolo}</div>
      {children}
    </section>
  );
}

export function Voce({
  chiave,
  valore,
  nota,
}: {
  chiave: string;
  valore: ReactNode;
  /** Da dove arriva il valore, o cosa lo rende inaffidabile. */
  nota?: string;
}) {
  return (
    <div className="sb-m-voce">
      <span className="sb-m-voce__chiave">
        {chiave}
        {nota && (
          <span className="sb-nota" style={{ display: 'block', marginTop: 4 }}>
            {nota}
          </span>
        )}
      </span>
      <span className="sb-m-voce__valore">{valore}</span>
    </div>
  );
}
